import Title from './Title';

import Paper from '@mui/material/Paper';
import { ThemeProvider } from '@material-ui/core'
import { createTheme } from '@material-ui/core/styles';
import { Typography, List, Grid, Button, Dialog } from '@mui/material';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import FolderIcon from '@mui/icons-material/Folder';
import ButtonBase from '@mui/material/ButtonBase';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ExpandIcon from '@mui/icons-material/ExpandMore';
import Accordion, { AccordionSlots } from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { GetAccessToken,GetAccessTokenM, fetcher } from './Utilities';
import useSWR from 'swr';
import LoadingOverlay from "react-loading-overlay";
import DarkBackground from "../Widgets/TransparentLoadingDisplay";
import AddIcon from "@mui/icons-material/Add";
//import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useAuth0 } from "@auth0/auth0-react";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import TextField from '@mui/material/TextField';

//import {Tooltip} from '@mui/material';
import { Stack, Alert, Collapse, Box, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Tooltip } from '@mui/material';

import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { set } from 'date-fns';
import { is } from 'date-fns/locale';



const containerStyle = {
  border: 'solid 0.125rem olive',
  margin: '0.5rem',
  width: '50vw'
};
const theme = createTheme({
  overrides: {
    MuiTableCell: {
      root: {  //This can be referred from Material UI API documentation. 
        padding: '0px 4px',
        // backgroundColor: "#eaeaea",
      },
    },
  },
});



const ChatCard = (props) => {
  const [accessToken, setAccessToken] = useState(false);
  const [postData, setPostData] = useState();
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [postToDelete, setPostToDelete] = useState(0);

  //GetAccessToken(setAccessToken, accessToken);
  var token = GetAccessToken(setAccessToken, accessToken,token);
  
  const { data, error, isLoading, mutate } = useSWR(['forum/getforumdata'], fetcher);


  const [expandedItem, setExpandedItem] = useState('');

  const [postContentOpen, setPostContentOpen] = useState(false);
  const [newTopicOpen, setNewTopicOpen] = useState(false);
  const [value, setValue] = useState('');
  const [topicValue, setTopicValue] = useState('');
  const [topicId, setTopicID] = useState('');
  const [successOpen, setSuccessOpen] = React.useState(false);
  const [errorOpen, setErrorOpen] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState(false);
  // const { user, isAuthenticated } = useAuth0();
  //console.log(renderData);
  if (data !== undefined && data !== null) {
    //setPostData(renderData);
  }
  const handleCancel = () => {
    setPostContentOpen(false);
  };
  const handleSave = (postId) => {
    //console.log(value);
    //debugger;
    //console.log(topicId);
    savePost();
    setPostContentOpen(false);
  };
  const handleDelete = () => {
    var data = { id: postToDelete };
    deletePost(postToDelete);
    setDeleteOpen(false);
  };
  const handleDeleteCancel = () => {
    setDeleteOpen(false);
  };
  const openPostContent = (event, topicId) => {
    setValue('');
    setTopicID(topicId);
    //console.log(topicId);
    setPostContentOpen(true);
  };


  const setNewTopicValue = (value, sectionId) => {
    setTopicValue(value);
    //console.log(value);
    //console.log(sectionId);
  };

  const setForumOpen = (name) => {
    if (expandedItem == name) {
      setExpandedItem('');
      return;
    }
    setExpandedItem(name);

  };
  const closeSuccess = () => {
    setSuccessOpen(false);
  };
  const closeError = () => {
    setErrorOpen(false);
  };
  const showError = () => {
    setErrorOpen(true);
    setTimeout(() => setErrorOpen(false), 3000);
  };

  const setNewTopicOpenState = () => {

    setNewTopicOpen(!newTopicOpen);
  };
  // const saveTopic = (sectionId) => {
  //   saveTopic(sectionId);
  //   setNewTopicOpenState();
  // };
  async function savePost() {

    var method = 'POST';
    var url = 'forum/addpost'
    var bearer = accessToken;

    var dataToSend = { value: value, topicId: topicId };
    try {
      const requestOptions = {
        method: method,
        withCredentials: true,
        credentials: 'include',
        headers: {
          'Authorization': bearer,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(dataToSend)
      };
      ///var returnData
      var result = await fetch(url, requestOptions).then(data => data.json()).then(
        (returnData) => {
          //renderData = returnData;
          setSuccessMessage('Post saved successfully.');
          setSuccessOpen(true);
          setTimeout(() => {
            setSuccessOpen(false);

          }, 3000);
          //isLoading = true;
          mutate(data, 'forum/getforumdata');
        });

      // if (result.status === 500) {
      //   showError();

      // } else {
      //   //debugger;
      //   setSuccessMessage('Post saved successfully.');
      //   setSuccessOpen(true);
      //   setTimeout(() => {
      //     setSuccessOpen(false);

      //   }, 3000);

      // }
    } catch (e) {

      showError();

    } finally {

    }
  }
  async function deletePost(id) {
    debugger;
    var method = 'DELETE';
    var url = 'forum/deletepost/' + id;
    var bearer = accessToken;

    //var dataToSend = { value: value, forumPostId: postToDelete };
    try {
      const requestOptions = {
        method: method,
        withCredentials: true,
        credentials: 'include',
        headers: {
          'Authorization': bearer,
          'Content-Type': 'application/json'
        },
        //body: JSON.stringify(dataToSend)
      };
      var result = await fetch(url, requestOptions);

      if (result.status === 500) {
        showError();
        //alert("Error");
      } else {
        setSuccessMessage('Post deleted successfully.');
        setSuccessOpen(true);
        setTimeout(() => {
          setSuccessOpen(false);
        }, 3000);
        mutate(data, 'forum/getforumdata');
      }
    } catch (e) {

      showError();

    } finally {

    }
  }
  async function saveTopic(sectionId) {
    setNewTopicOpenState();
    var method = 'POST';
    var url = 'forum/addTopic'
    var bearer = accessToken;

    var dataToSend = { sectionId: sectionId, topic: topicValue };
    try {
      const requestOptions = {
        method: method,
        withCredentials: true,
        credentials: 'include',
        headers: {
          'Authorization': bearer,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(dataToSend)
      };

      var result = await fetch(url, requestOptions);

      if (result.status === 500) {
        showError();
        //alert("Error");
      } else {
        setSuccessMessage('Topic saved successfully.');
        setSuccessOpen(true);
        setTimeout(() => {
          setSuccessOpen(false);
        }, 3000);
        mutate(data, 'forum/getforumdata');
      }
    } catch (e) {

      showError();

    } finally {

    }
  }
  //console.log(data);
  var modules = {
    toolbar: [
      [{ 'header': [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
      ['link', 'image'],
      ['clean']
    ],
  };

  var formats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image'
  ];
  if (isLoading ) {
    return (

      <DarkBackground >
        <LoadingOverlay
          active={true}

          spinner={true}
          text="Loading..."
        >
        </LoadingOverlay>
      </DarkBackground>

    )
  }
  else {
    return (
      <Fragment>
        <Collapse in={successOpen}  >
          <Stack spacing={2}>
            <Alert severity="success" onClose={() => closeSuccess()}>{successMessage}</Alert>
          </Stack>
        </Collapse>
        <Collapse in={errorOpen}  >
          <Stack spacing={2}>
            <Alert severity="error" onClose={() => closeError()}>An error occured</Alert>
          </Stack>
        </Collapse>


        <ThemeProvider theme={theme}>
          <Title>{props.title}</Title>

          <Typography variant="h6" >
            Forums
          </Typography>

          <List >

            {data.data.map((forum, index) =>
              <Fragment key={index}>
                <ButtonBase onClick={() => setForumOpen(forum.sectionName)}>
                  <ListItem key={index} >
                    <ListItemAvatar>
                      <Avatar>
                        <FolderIcon />
                      </Avatar>
                    </ListItemAvatar>
                    {/* <ListItemText key={index} style={{ fontWeight: 'bold' }}
                      primary={forum.sectionName}

                    /> */}
                    <Typography variant="subtitle1">
                      <Box component="span" fontWeight='fontWeightMedium'>{forum.sectionName}</Box>

                    </Typography>


                  </ListItem>
                </ButtonBase>
                <Collapse in={expandedItem == forum.sectionName} width={'100%'}>
                  {(!forum.adminOnly || data.isAdmin) && (
                    <Box key={'m' + index} sx={{ border: 0 }} px={2} py={0}>
                      <Grid key={'l' + index} container>

                        <Grid item xs={2} sm={2} >
                          <Button sx={{ px: 1 }} style={{ maxHeight: '25px', minWidth: '30px', minHeight: '25px', marginTop: '8px' }}
                            variant="outlined"
                            color="primary"
                            onClick={(event) => {
                              setNewTopicOpenState();
                            }}
                          >
                            New Topic
                            {/* <AddIcon /> */}
                          </Button>
                        </Grid>
                        {newTopicOpen && (

                          <Fragment>
                            <Grid item xs={4} sm={4} >


                              <TextField style={{ marginTop: '0px' }}

                                size="small"
                                onChange={(event) => { setNewTopicValue(event.target.value, forum.sectionId) }}
                                id="id"
                                name="id"
                                label="Enter new topic"
                                fullWidth

                                margin="dense"
                                placeholder='Enter new topic'


                              />
                            </Grid>
                            <Grid item xs={4} sm={4} >
                              <Box key={'m' + index} sx={{ border: 0 }} px={2} py={0}>
                                <Button sx={{ px: 1 }} style={{ maxHeight: '25px', minWidth: '30px', minHeight: '25px', marginTop: '8px' }}
                                  variant="outlined"
                                  color="primary"
                                  onClick={(event) => {
                                    saveTopic(forum.sectionId);
                                  }}
                                >
                                  Create
                                  {/* <AddIcon /> */}
                                </Button>
                                {/* </Box>
                              <Box key={'m' + index} sx={{ border: 0 }} px={2} py={0}> */}
                                <Button sx={{ px: 1 }} style={{ maxHeight: '25px', minWidth: '30px', minHeight: '25px', marginTop: '8px' }}
                                  variant="outlined"
                                  color="primary"
                                  onClick={(event) => {
                                    setNewTopicOpenState();
                                  }}
                                >
                                  Cancel


                                  {/* <AddIcon /> */}
                                </Button>
                              </Box>
                            </Grid>




                          </Fragment>
                        )}

                      </Grid>
                    </Box>
                  )}
                  <Box key={index} sx={{ border: 0 }} px={2} py={0}>
                    <Grid key={'f' + index} container>
                      {forum.forumTopics.map((topic, index) =>
                        <Fragment key={'g' + index}>

                          <Grid key={'a' + index} item xs={10} fontWeight='fontWeightMedium'>{topic.topicName}
                            {/* <Grid key={'h'+index} item xs={3} >{topic.posts.length} posts</Grid> */}



                          </Grid>
                          <Grid key={'k' + index} item xs={2} >
                            <Button sx={{ px: 1 }} style={{ maxHeight: '25px', minWidth: '30px', minHeight: '25px' }}
                              variant="outlined"
                              color="primary"
                              onClick={(event) => {
                                //alert('This feature is under construction');
                                openPostContent(event, topic.topicId);
                                //handleClickOpen(event, cellValues, vendorData.accessToken);
                              }}
                            >
                              Add Post
                              {/* <AddIcon /> */}
                            </Button>
                          </Grid>

                          {topic.posts.map((post, index) =>
                            <Grid key={'b' + index} container spacing={3} direction="row" justify="center" alignItems="stretch">
                              {/* <Grid key={'c' + index} item lg={.1} md={.1} sm={.1} /> */}
                              <Grid key={'d' + index} item xs={8} marginLeft={1} border={0}>
                                <div dangerouslySetInnerHTML={{ __html: post.postContent }} />
                              </Grid>
                              <Grid key={'e' + index} item xs={3} border={0} >
                                By: {post.userNickname}&nbsp;

                                {( data.isAdmin || post.userId === data.userId) && (
                                  // ( data.isAdmin || post.userId === data.userId) && (

                             
                                  <Button
                                    sx={{ minWidth: 34, padding: 0 }}
                                    variant="outlined"
                                    color="primary"
                                    onClick={(event) => {
                                      //alert('Edit PIA' + row.id);
                                      setDeleteOpen(true);
                                      setPostToDelete(post.forumPostId);

                                      //alert('This feature is under construction.  Delete: ' + post.forumPostId);
                                      //window.location.href = '/apps/' + row.id
                                    }}
                                  >
                                    <DeleteIcon />
                                  </Button>

                                )}

                              </Grid>

                            </Grid>

                          )}


                        </Fragment>
                      )}
                    </Grid>
                  </Box>
                </Collapse>

              </Fragment>
            )}

          </List>
          <Dialog open={deleteOpen} onClose={handleDeleteCancel}>
          <DialogTitle>Delete Post</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you wish to Delete this post?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={handleDelete}>Delete</Button>
            <Button onClick={handleDeleteCancel}>Cancel</Button>
          </DialogActions>
        </Dialog>
          <Dialog open={postContentOpen} onClose={handleCancel} maxWidth="md" fullWidth={true}>
            <DialogTitle>

              <Box
                component="span"
                m={1}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                // border={3}
                sx={{ color: 'text.primary', fontSize: 34, fontWeight: 'medium' }}
              >

                Create Post
              </Box>

            </DialogTitle>
            <DialogContent>

              <ReactQuill id='postContent' bounds={'#postContent'} style={{ minWidth: '600px', minHeight: '100px' }} theme="snow" value={value} onChange={setValue} modules={modules} formats={formats} />
            </DialogContent>

            <DialogActions>
              {/* {vendorData.userAndTenant.isSuperAdmin && tenantId > 0 && (
                <Button color="primary" onClick={handleSubmit(onApprove)}>Approve</Button>
              )}
              {vendorData.userAndTenant.isSuperAdmin && (
                <Button color="primary" onClick={handleSubmit(onSubmit)}>Save</Button>
              )}
              {!vendorData.userAndTenant.isSuperAdmin && (
                <Button color="primary" onClick={handleSubmit(onSubmit)}>Submit Vendor to ProcessPro</Button>
              )} */}
              <Button onClick={handleSave}>Save</Button>
              <Button onClick={handleCancel}>Cancel</Button>

            </DialogActions>
          </Dialog>

        </ThemeProvider>
      </Fragment>
    );
  }
}
export default ChatCard;